import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { CheckException } from '@treasury/domain/arp';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/forms/tm-form-row';
import '@treasury/presentation/components/layout/tm-section';
import '@treasury/presentation/components/tm-blocking-loader';
import '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-footer';
import { TextFieldValueChangedEvent } from '@vaadin/text-field';
import { css, html, PropertyValueMap } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { filterTableResults } from '../../../../../utilities/table-result-filter';
import '../../../components/decision-toggle';
import './check-exceptions-table';

export const tagName = 'check-exceptions-decisions-review';
@customElement(tagName)
export class CheckExceptionsReview extends TmBaseComponent {
    @property({ type: Array })
    public checkExceptions!: Array<CheckException>;

    @property()
    public showTitle = true;

    @property()
    public showSubmit = true;

    @InjectProperty()
    declare private navService: NavigationService;

    @state()
    private filteredItems = this.checkExceptions;

    @state()
    private showSearch = false;

    @state()
    private showFilters = false;

    @state()
    private filters = [];

    @state()
    private searchString = '';

    @state()
    private showSelectAllOptions = false;

    private readonly fieldsToFilter = [
        'accountNumber',
        'checkNumber',
        'paidAmount',
        'exceptionReason',
    ];

    public render() {
        return html`
            <tm-section>
                <h1 class="border-b p-4">Check Exceptions</h1>
                <check-exceptions-table
                    .checkExceptions=${this.checkExceptions}
                    readonly
                ></check-exceptions-table>
            </tm-section>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: `Decision (${this.checkExceptions.length})`,
                        onClick: () => this.handleSubmitClick(),
                    },
                ]}
            >
            </tm-footer>
        `;
    }

    protected updated(
        _changedProperties: PropertyValueMap<CheckExceptionsReview> | Map<PropertyKey, unknown>
    ): void {
        if (_changedProperties.has('checkExceptions')) {
            this.filteredItems = this.checkExceptions;
            this.filters = [];
        }
    }

    private toggleSearchBar() {
        this.showSearch = !this.showSearch;
    }

    private toggleShowSelectAllOptions() {
        this.showSelectAllOptions = !this.showSelectAllOptions;
    }

    private payAll() {
        const exceptions = this.filteredItems.map((exception: CheckException) => {
            exception.pay();
            return exception.clone();
        });
        this.filteredItems = exceptions;
    }

    private returnAll() {
        this.filteredItems = this.filteredItems.map((exception: CheckException) => {
            exception.return();
            return exception.clone();
        });
    }

    private search() {
        this.filteredItems = filterTableResults(
            new CustomEvent(this.searchString),
            this.checkExceptions,
            [...this.fieldsToFilter, 'issuedPayee']
        ) as CheckException[];
    }

    private filter(e: TextFieldValueChangedEvent) {
        this.filteredItems = filterTableResults(
            e,
            this.checkExceptions,
            this.fieldsToFilter
        ) as CheckException[];
    }

    private handleSubmitClick() {
        this.dispatchEvent(new CustomEvent('submit'));
    }

    public static get styles() {
        return [
            css`
                :host {
                    --icon-svg-transform: scale(1) !important;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CheckExceptionsReview;
    }
}
